import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { AppsDataService } from '../../../services/apps.service';
import { ToastrService } from 'ngx-toastr';
import { SharedDataService } from 'src/app/modules/shared/services/shared.service';
import { DatePipe } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { JwtHelperService } from "@auth0/angular-jwt";
import { map } from "rxjs/operators";
import { environment } from "src/environments/environment";
import { DeepLearningDataService } from 'src/app/modules/IoTCore/deepLearning/services/deepLearning';

declare var $: any;
@Component({
    // selector: 'app-billing-alert-dialog',
    templateUrl: './billing-model-dialog.html',
    styleUrls: ['./billing-model-dialog.css']
})
export class BillingModelAlertDialogComponent implements OnInit {
    public personData: any[] = [];
    public personDataDetails: any;
    tokenDecoded: any = {};
    public apiMetaDataLoading: boolean = false;
    public eventMetaData: any = {};
    public currentImage: any;
    public modelImage: any;
    public modelCount: any;
    public modelName: any;
    public modelobjectId: any;
    public modelAccuracy: any;
    public modelvideoTimestamp: any;




    public isimageReady: boolean = false;
    personProfile: any;
    isVideoReady: boolean = false;
    currentvideo: any;
    // isMerakiCam: boolean = false;
    isMerakiCam: boolean = false;
    public isPersonFound: boolean = true;
    private JWT: JwtHelperService = new JwtHelperService();
    constructor(
        private _datepip:DatePipe,
        private dialog: MatDialog,
        public dialogRef: MatDialogRef<BillingModelAlertDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public eventData: any,
        private _DeepLearningDataService: DeepLearningDataService
    ) {
    }

    ngOnInit() {
        // 
        this.getAllPersonData();
        this.getTenantFromLocalStorage();
    }


    convertToLocalTime(utcTimestamp: string): string {    
        const localDate = new Date(utcTimestamp);
        localDate.setHours(localDate.getHours() - 5);
    
        return this._datepip.transform(localDate, 'MMM d, y, h:mm:ss a');
      }


    getAlertData(item: any) {

        this.modelImage = item.imageUrl;
        this.modelCount = item.count;
        this.modelName = item.dlModelName;
        this.modelobjectId = item.objectId;
        this.modelAccuracy = item.accuracy;
        this.modelvideoTimestamp = item.videoTimestamp;

        console.log(">>>.here is dialog ts>>>>>>>>>>>from MODEL CLICK", item);
        console.log(">>>.here is dialog ts iiimmmmaaaaggggeeee>>>>>>>>>>>", item.snapshot_image);


        // 
        this.isimageReady = false;
        if (this.tokenDecoded.tenantId == 4 && (item.label == 'faceMaskDetected' || item.label == 'socialDistancingViolation')) this.getMetaData(item.objectId);

        this.findPersonName(item.value);
        this.getsnapShotForAlert(item.snapshot_image);
        if (item.snapshotVideo.includes("meraki")) {
            this.isMerakiCam = true;
        }
        else {
            this.isMerakiCam = false;
            this.getvideoForAlert(item.snapshotVideo);
        }
    }
    getTenantFromLocalStorage() {
        // let token = localStorage.getItem('token');
        let token = localStorage.getItem(environment.ProjectName + '-token');
        this.tokenDecoded = this.JWT.decodeToken(token);
    }
    getAllPersonData() {
        this._DeepLearningDataService.getAllPerson().subscribe((res) => {
            this.personData = res.body["data"];
            this.getAlertData(this.eventData);
        });
    }
    getsnapShotForAlert(name) {
        console.log(">>>>>>>>>>>>>my image path billing alert image mname", name);

        this._DeepLearningDataService.getRequiredFile(name).subscribe((res) => {
            this.currentImage = res.body["url"];
            console.log(">>>>>>>>>>>>>my image path billing alert", res.body["url"]);

            this.isimageReady = true;
            setTimeout(() => {
                $(".imageZoom").magnificPopup({ type: "image" });
            }, 1000);
        });
    }
    getvideoForAlert(name) {
        this._DeepLearningDataService.getRequiredFile(name).subscribe((res) => {
            this.currentvideo = res.body["url"];
            this.isVideoReady = true;
        }, error => {
            this.isVideoReady = false;
        });
    }
    getMetaData(objectId: string) {
        let todayDate = new Date();
        this.eventMetaData = {};
        this.apiMetaDataLoading = true;

        let range = `${todayDate.getFullYear()}-${(todayDate.getMonth() + 1) > 9 ? todayDate.getMonth() + 1 : '0' + (todayDate.getMonth() + 1)}-${todayDate.getDate() > 9 ? todayDate.getDate() : '0' + todayDate.getDate()}`;
        let query = {
            "queryType": "scan",
            "limit": 10,
            "order": "descending",
            "intervals": [
                "2020-06-29T19:00:00.000Z/" + range + "T18:59:59.999Z"
            ],
            "filter": {
                "type": "and",
                "fields": [
                    {
                        "type": "selector",
                        "dimension": "objectId",
                        "value": objectId
                    }
                ]
            },
            "offset": 0
        };

        this._DeepLearningDataService.videoEventsQuery(query)
            .pipe(map(res => res.body))
            .subscribe(
                (response: any) => {

                    if (response.length > 0) {
                        response[0].events.forEach(element => {
                            this.eventMetaData[element.label] = element.value;
                        });
                    }
                    this.apiMetaDataLoading = false;
                },
                (error) => {
                    this.apiMetaDataLoading = false;
                }
            );
    }
    findPersonName(id) {
        this.isPersonFound = true;
        var findPerson = this.personData.find((x) => x.id == id);
        if (findPerson != null && findPerson.isActive) {
            this.personDataDetails = findPerson;
        } else {
            this.personDataDetails = {
                firstName: "Guest",
                lastName: "",
                employeeTags: [{ name: "Guest" }],
            };
        }
        this.isPersonFound = false;
    }
    preventDownload(event: Event): void {
        // Prevent the default behavior of the click event
        event.preventDefault();
      }
    closeModel() {
        this.dialogRef.close();
    }

}
